import { ResourceTypes } from './tablelist.enum';
import { EventEmitter } from '@angular/core';
import { DynamicSearchPayload } from '@ispm-shared/modules/common/dynamic-search';
import { SimpleSearchOrigin, ISimpleSearchConfig } from './simple-search.interface';

export interface ITablelistIds {
  ids: Array<string>;
  resourceType: ResourceTypes;
  configTemplateType: string;
}
export interface ITablelistClear {
  resourceType: ResourceTypes;
  configTemplateType: string;
}

export interface ITablelistStateIdentifierData {
    configTemplate: any;
    aggIds: {[key : string]:{} };
}
export interface ITablelistStateActionPageIdsTemplate {
  resources_ids: Array<string>;
  totalEntities: number;
  resourceType: ResourceTypes;
  configTemplateType: string;
}

export interface ITablelistRequester {
  adaptableFilters?: any;
  additionalResourcesToRetrieve?: any;
  associationItems?: Array<any>;
  configTemplateType: string;
  currentPage?: number;
  dynamicSearch?: DynamicSearch;
  ids?: any[];
  items?: any[];
  offset: number;
  onSearchEndEvent?: EventEmitter<boolean>;
  paginate?: boolean;
  preventLazyLoad?: boolean;
  queryOrigin?: SimpleSearchOrigin;
  queryType?: string;
  resetIds: boolean;
  resource?: string;
  resourceQuery?: any;
  resourceType: ResourceTypes;
  searchTerm: string;
  simpleSearch?: ISimpleSearchConfig;
  sortByField?: string;
  sortByOrder?: string | number;
  sortByType?: string;
  start: number;
}

export interface DynamicSearch {
  multipleSearch?: boolean;
  clubbed?: boolean;
  sortPath?: boolean;
  idQuery: DynamicSearchPayload;
  dataQuery: DynamicSearchPayload;
}
